import type { ReportingQueryProps } from "@/screens/app/reporting/reporting-query"
import {
	formatDurationHours,
	formatDurationHoursNodes,
	ReportingMetricTrendCard,
} from "@/components/reporting/charts"
import { api } from "@/lib/api"

interface ImplementationChartProps extends ReportingQueryProps {
	className?: string
}

export const ImplementationChart = ({
	className,
	startDate,
	endDate,
	...filters
}: ImplementationChartProps) => {
	const metricsQuery = api.workspace.getImplementationTime.useQuery(
		{ startDate, endDate, ...filters },
		{
			cacheTime: Infinity,
			staleTime: 60_000,
		},
	)

	const hours = metricsQuery.data?.recentAvgHours

	return (
		<ReportingMetricTrendCard
			className={className}
			title="Time from report to implementation"
			description="Median hours from conversation created to the first linked Linear issue completed. Trend uses weekly or monthly buckets on longer ranges."
			value={hours != null && hours > 0 ? formatDurationHoursNodes(hours) : "-"}
			data={metricsQuery.data?.series ?? []}
			isLoading={!metricsQuery.data}
			tone="categorical-4"
			valueFormatter={formatDurationHours}
			connectNulls
			minPoints={3}
		/>
	)
}
